import ShippingOptionsCustomerTable, {
  CrmReceiverCustomer,
} from '../ShippingOptionsCustomerTable';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import CrmCustomerListFilter, {
  CrmFilterFormValues,
} from '../CustomerListFilter';
import { Button, Col, Divider, Row } from 'antd';
import AntdFeatherIcon from '@/components/_common/AntdFeatherIcon';
import { ArrowLeft, ArrowRight } from 'react-feather';
import { FormattedMessage } from 'react-intl';
import { useState } from 'react';
import { DateTimeFormat } from '@/utils/moment';
import { CrmCustomerListProps } from '@/core/domain/crm/CrmList/CrmList.types';
import { SendOptionType } from '@/core/domain/crm/SendOptions/SendOptions.types';
import { useQueryParams } from '@/hooks/useQueryParams';
import { useCrmCustomerRecoveryDebtsList } from '@/core/domain/crm/CrmList/CrmList.hooks';
import { useWindowSize } from '@/hooks';

const CrmCustomersDebtsList: React.FC<CrmCustomerListProps> = ({
  onPrev,
  CustomersSelected,
  onCustomersSelected,
  customerIds,
}) => {
  const [filter, setFilter] = useState<CrmFilterFormValues>();
  const { type } = useQueryParams<{ type?: SendOptionType }>();
  const { isMobile } = useWindowSize();

  const queryReturn = useCrmCustomerRecoveryDebtsList({
    ...filter,
    dueDateInitial:
      type === SendOptionType.recoveryOfDebts
        ? filter?.dueDateInitial?.format(DateTimeFormat)
        : undefined,
    dueDateFinal:
      type === SendOptionType.recoveryOfDebts
        ? filter?.dueDateFinal?.format(DateTimeFormat)
        : undefined,
  });

  const items = flatInfiniteData(queryReturn?.data);

  const dataSource = items.map<CrmReceiverCustomer>(
    ({ customer, ...item }) => ({
      id: item.id,
      customer: customer,
      debit: item,
    }),
  );

  return (
    <>
      <CrmCustomerListFilter onFilter={setFilter} />

      <Divider />

      <ShippingOptionsCustomerTable
        dataSource={dataSource}
        loading={queryReturn?.isLoading}
        CustomersSelected={CustomersSelected}
        onCustomersSelected={onCustomersSelected}
        customerIds={customerIds}
        refetch={queryReturn?.refetch}
        fetchNextPage={queryReturn?.fetchNextPage}
        hasNextPage={queryReturn?.hasNextPage}
        isFetching={queryReturn?.isFetching}
      />

      <Row gutter={[24, 24]} style={{ marginTop: 24 }} justify="end">
        <Col span={isMobile ? 24 : undefined}>
          <Button onClick={onPrev} block>
            <AntdFeatherIcon icon={<ArrowLeft />} size={12} />
            <FormattedMessage id="commons.modal.button.back" />
          </Button>
        </Col>

        <Col span={isMobile ? 24 : undefined}>
          <Button htmlType="submit" block>
            <AntdFeatherIcon icon={<ArrowRight />} size={12} />
            <span>Continuar</span>
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default CrmCustomersDebtsList;
